import { useState } from "react";
import { AES, enc } from "crypto-js";
import config from "config/Config.js";

export function useLocalStorage(key: string, initialValue: any) {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const encrypted = window.localStorage.getItem(key);
      if (encrypted !== null) {
        const decrypted = AES.decrypt(
          encrypted,
          config.ENC_KEY || "DefaultKey"
        );
        return JSON.parse(decrypted.toString(enc.Utf8));
      } else {
        return initialValue;
      }
    } catch (error) {
      console.log(error);
      return initialValue;
    }
  });

  const setValue = (value: Function | string) => {
    try {
      const valueToStore =
        value instanceof Function ? value(storedValue) : value;
      setStoredValue(valueToStore);
      const encryptedString = AES.encrypt(
        JSON.stringify(valueToStore),
        config.ENC_KEY || "DefaultKey"
      ).toString();
      window.localStorage.setItem(key, encryptedString);
    } catch (error) {
      console.log(error);
    }
  };
  return [storedValue, setValue];
}
